/**
 * 前端写死菜单，无需接口权限
 */
export const menuList = [
  {
    index: 'config-mgmt',
    title: '运营管理',
    icon: 'el-icon-s-operation',
    children: [
      {
        index: 'mini-programs',
        title: '小程序配置',
        path: '/mini-programs'
      },
      {
        index: 'templates',
        title: '模板管理',
        path: '/templates'
      }
    ]
  }
]
